// App.js
// Konum: src/App.js — üzerine yaz (create-react-app'in varsayılan içeriğini siler)

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CagriBellGiris from './CagriBellGiris';
import CagriBellAdmin from './CagriBellAdmin';
import TvCagriEkrani from './TvCagriEkrani';
import GarsonCagirButonu from './GarsonCagirButonu';
import GarsonEkrani from './GarsonEkrani';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<CagriBellGiris />} />
        <Route path="/admin" element={<CagriBellAdmin />} />
        <Route path="/tv/:restaurantId" element={<TvCagriEkrani />} />
        <Route path="/cagir/:restaurantId/:tableId/:tableNumber" element={<GarsonCagirButonu />} />
        <Route path="/garson/:restaurantId/:waiterId" element={<GarsonEkrani />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;